import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { NavDropdown, ListGroup } from "react-bootstrap";
import TypeAhead from "./TypeAhead";
import NavbarLink from "./NavbarLink";
const Contacts = ({ CanI }) => {
    const [state, setState] = useState({ contacts_add: false });

    useEffect(() => {
        async function InitAsset() {
            setState({
                ...state,
                contacts_add: await CanI("contacts_add")
            });
        }
        InitAsset();
        return setState({
            ...state,
            contacts_add: false
        });
    }, []);
    const { contacts_add } = state;

    return (
        <NavDropdown.ItemText>
            <ListGroup>
                <ListGroup.Item>
                    <NavbarLink
                        to="/app/contacts"
                        className="dropdown-item"
                        label={"List View"}
                    />
                </ListGroup.Item>
                {contacts_add && (
                    <ListGroup.Item>
                        <NavbarLink
                            to="/app/contacts/add"
                            className="dropdown-item"
                            label={"Add"}
                        />
                    </ListGroup.Item>
                )}
                <ListGroup.Item className="px-3">
                    <TypeAhead
                        component="contacts"
                        style={{ minWidth: "150px" }}
                        type="text"
                        className="form-control"
                        placeholder="Search..."
                    />
                </ListGroup.Item>
            </ListGroup>
        </NavDropdown.ItemText>
    );
};

Contacts.propTypes = { CanI: PropTypes.func };

export default Contacts;